import { brandController } from '@/apis/core';

export const getBrandNameAutocompleteOptions = async (
  type: 'displayName' | 'companyName',
  value: string,
  status?: string
): Promise<string[]> => {
  const response = await brandController.getBrandSuggestions({
    prefix: type === 'displayName' ? value : undefined,
    companyNamePrefix: type === 'companyName' ? value : undefined,
    limit: 20,
    status,
  });
  return (
    response?.map((suggestion) =>
      type === 'displayName'
        ? suggestion.brandName
        : suggestion.brandCompanyName
    ) || []
  );
};
